import store from "."
import {
    logoutInternalUser, logoutSuperAdmin, logoutStudent, logoutIndustry, logoutMerchant
} from "./actions"
import { useSelector } from "react-redux"
import { toast } from "react-toastify"
import { setStudentDashboard } from "./actions/studentDashboardActions";

export function updateDashboardState(role, data) {
    switch (role) {
        case "Student":
            store.dispatch(setStudentDashboard(data));
            break;
        default:
            break;
    }
}

export function useSelectAccess(role) {
    return useSelector((store) => {
        switch (role) {
            case "Super Admin":
                return store.superadmin
            case "Internal User":
                return store.internaluser
            case "Student":
                return store.student
            case "Industry User":
                return store.industry
            case "Merchant":
                return store.merchant
            default:
                return null;
        }
    })
}

export function logoutAccess(role) {
    switch (role) {
        case "Super Admin":
            store.dispatch(logoutSuperAdmin());
            break;
        case "Internal User":
            store.dispatch(logoutInternalUser());
            break;
        case "Student":
            store.dispatch(logoutStudent());
            break;
        case "Industry User":
            store.dispatch(logoutIndustry());
            break;
        case "Merchant":
            store.dispatch(logoutMerchant());
            break;
        default:
            return;
    }
    toast.info("Logout successful", { toastId: "LogoutReplacable" });
} 
